import React from 'react';
import { Link } from 'react-router-dom';
import styles from './Expectations.module.css';

interface CardData {
  icon: string;
  title: string;
  text: string;
}

const cards: CardData[] = [
  {
    icon: '/assets/images/icon-conference.png',
    title: 'Des conférences et des invités B2B ambitieux :',
    text: "Y'aura du lourd, des professionnels, toutes industries confondues, avec les mêmes problématiques que tout le monde dans le B2B.",
  },
  {
    icon: '/assets/images/icon-sessions.png',
    title: 'Des sessions thématiques',
    text: "La transformation digitale des distributeurs B2B, c'est pas easy peasy. Assistez à des talks, repartez avec des idées, des use cases et des méthodes.",
  },
  {
    icon: '/assets/images/icon-networking.png',
    title: 'du networking',
    text: 'Vos potos décideurs sont là. Rencontrez des décideurs et des pairs de l\'industrie, des potos pour la vie du B2B.',
  },
];

const Expectations: React.FC = () => {
  return (
    <div className={styles.wrapper}>
      {/* Title on white background */}
      <div className={styles.titleSection}>
        <h2 className={styles.title}>À quoi vous attendre à B2B ?</h2>
      </div>
      {/* Cards on confetti background – contained rectangle */}
      <section
        className={styles.section}
        style={{
          background: 'url(/assets/backgrounds/confetti-bg.svg) repeat',
          backgroundSize: 'contain',
        }}
      >
        <div className={styles.cards}>
          {cards.map((card, index) => (
            <div key={index} className={styles.card}>
              <img src={card.icon} alt={card.title} className={styles.cardIcon} />
              <h3 className={styles.cardTitle}>{card.title}</h3>
              <p className={styles.cardText}>{card.text}</p>
            </div>
          ))}
        </div>
        <div className={styles.ctaWrapper}>
          <Link to="/inscriptions" className={styles.ctaButton}>
            S'INSCRIRE À B2B
          </Link>
        </div>
      </section>
    </div>
  );
};

export default Expectations;
